import { render } from "./BurnCustomCurr.vue?vue&type=template&id=90e683bc&scoped=true"
import script from "./BurnCustomCurr.vue?vue&type=script&lang=js"
export * from "./BurnCustomCurr.vue?vue&type=script&lang=js"

import "./BurnCustomCurr.vue?vue&type=style&index=0&id=90e683bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e683bc"]])

export default __exports__